<div
  class="legend-box-container"
  [ngClass]="{
    collapsed: collapsed,
    empty: !rows.length
  }"
>
  <!-- This is the template when is collapsed -->
  <div class="condensed-container" (click)="open($event)" *ngIf="collapsed">
    <ng-container *ngTemplateOutlet="iconCollapsedTmpl"> </ng-container>
  </div>

  <!-- This is the template when is expanded -->
  <ng-container *ngIf="!collapsed">
    <span class="icon-close" (click)="close()"></span>

    <!--  if there are no items to draw we hide the row -->
    <div class="legend-box-row" *ngFor="let row of rows">
      <div class="legend-box-title" [title]="row.title">
        <span class="inner" *ngIf="row.title && row.title.length">
          {{ row.title }}
        </span>
      </div>
      <!--  CIRCLE TYPE -->
      <ng-container *ngIf="row.type === 'circle'">
        <div class="legend-box-content circle-type">
          <div class="legend-box-detail" *ngFor="let item of row.items">
            <div class="circle-color" [ngStyle]="{ background: item.color || null }"></div>
            {{ item.label || item }}
          </div>
        </div>
      </ng-container>

      <!--  LINE TYPE -->
      <ng-container *ngIf="row.type === 'line'">
        <div class="legend-box-content line-type">
          <div class="legend-box-detail" *ngFor="let item of row.items">
            <div class="line-color" [ngStyle]="{ background: item.color || null }"></div>
            {{ item.label || item }}
          </div>
        </div>
      </ng-container>

      <!--  SIZE TYPE -->
      <ng-container *ngIf="row.type === 'size'">
        <div class="legend-box-content size-type">
          <div class="legend-box-detail" *ngFor="let item of row.items">
            <div class="size-circle" [ngStyle]="{ width: item.size + 'px' || null, height: item.size + 'px' }"></div>
            <div class="size-label">
              {{ item.label || item }}
            </div>
          </div>
        </div>
      </ng-container>

      <!--  BAR TYPE -->
      <ng-container *ngIf="row.type === 'bar'">
        <div class="legend-box-content bar-type">
          <div class="legend-box-detail" *ngFor="let item of row.items">
            <div class="bar-color" [ngStyle]="{ background: item.color || null }"></div>
            {{ item.label || item }}
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="!row.type">
        <div class="legend-box-content">
          <div class="legend-box-detail" *ngFor="let item of row.items; let i = index">
            <ng-container *ngTemplateOutlet="optionsListTmpl; context: { $implicit: item, row: row.title, index: i }"> </ng-container>
          </div>
        </div>
      </ng-container>
    </div>
  </ng-container>
</div>
